
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"66","viewBox":"0 0 80 66"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M79 59.2L44.6 2.8c-2.3-3.8-6.1-3.8-8.4 0L1 59.2C-1.3 62.9.4 66 4.8 66h70.3c4.4 0 6.2-3.1 3.9-6.8zM43.4 15.5l-.9 28.9h-3.6l-1-28.9h5.5zm-2.8 40.7c-1.7 0-3.2-1.5-3.2-3.2 0-1.7 1.4-3.2 3.2-3.2 1.7 0 3.3 1.5 3.3 3.2 0 1.7-1.5 3.2-3.3 3.2z"}})])
          )
        }
      }
    